module.exports = __webpack_public_path__ + "static/media/Terms_and_Conditions.e8011f29.pdf";